import Content, {IContent} from "@/model/Content/Content"
import ServiceTypeEnum from "@/config/serviceTypeEnum"

import Image from "@/model/Image/Image"
import hasServiceFamily, {IHasServiceFamily} from "@/model/mixins/ServiceFamily/hasServiceFamily"

type Translation = {[locale: string]: string}



class ServiceFamilyContentBase extends Content {
    private name: Translation
    private description: Translation
    private image: Image
    private type: ServiceTypeEnum

    constructor(name: Translation, description: Translation, image: Image, type: ServiceTypeEnum) {
        super()
        this.name = name
        this.description = description
        this.image = image
        this.type = type
    }

    public getName(): Translation {
        return this.name
    }
    public getDescription(): Translation {
        return this.description
    }
    public getImage(): Image {
        return this.image
    }
    public getType(): ServiceTypeEnum {
        return this.type
    }
}

export interface IServiceFamilyContent extends ServiceFamilyContentBase, IContent, IHasServiceFamily {
    getName(): Translation
    getDescription(): Translation
    getImage(): Image
    getType(): ServiceTypeEnum
}

// apply mixins
const ServiceFamilyContent: Constructor<IServiceFamilyContent> = hasServiceFamily(ServiceFamilyContentBase)

export default ServiceFamilyContent